import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    // Create the form dynamically since Rails isn't rendering the form tag properly
    this.createFamilyPlanForm();

    // Handle family plan enrollment banner clicks
    this.clickHandler = this.handleClick.bind(this);
    document.addEventListener("click", this.clickHandler);

    // Handle URL-based redirect (for direct access)
    this.handleDirectUrlAccess();
  }

  createFamilyPlanForm() {
    // Extract the form content that Rails rendered (without the form tag)
    const existingContent = this.element.innerHTML;

    // Wrap it in a proper form tag
    this.element.innerHTML = `
      <form id="enroll-in-family-plan-form" class="w-full" action="/portal/ticket_requests" method="post" data-turbo-action="advance">
        ${existingContent}
      </form>
    `;
  }

  disconnect() {
    document.removeEventListener("click", this.clickHandler);
  }

  handleClick(event) {
    const link = event.target.closest("a");
    if (link && link.href && link.href.includes("redirect_to_enroll_in_family_plan_flow=true")) {
      event.preventDefault();
      this.enrollInFamilyPlan();
    }
  }

  handleDirectUrlAccess() {
    if (window.location.search.includes("redirect_to_enroll_in_family_plan_flow=true")) {
      history.replaceState({}, "", "/portal");
      this.enrollInFamilyPlan();
    }
  }

  enrollInFamilyPlan() {
    const form = this.element.querySelector("form#enroll-in-family-plan-form");
    if (form) {
      form.requestSubmit();
    }
  }
}
